import * as api from '../../services/print_template/api_print_template';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { IS_DONE_LOADING_PREVIEW, IS_LOADING_PREVIEW } from '../../constants';

export function* savePrintTemplateSaga(feathersApp) {
  yield takeLatest('SAVE_PRINT_TEMPLATE', callSavePrintTemplate, feathersApp);
}
function* callSavePrintTemplate(feathersApp, action) {
  const { tenant, user = {}, silent } = yield select();
  const data = { ...action.data };
  try {

    yield common.showProgressSaveRecord(silent);
    const result = yield call(api.savePrintTemplate, feathersApp, {
      tenant,
      user,
      data
    });

    yield callFetchPrintTemplateForEdit(feathersApp, { id: result.id, silent: true });
    browserHistory.push(`/admin/print_template/edit/${result.id}`);
    yield common.doneSaveRecord(result, 'Print template was saved.');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}




export function* fetchPrintTemplateForEditSaga(feathersApp) {
  yield takeEvery('FETCH_PRINT_TEMPLATE_FOR_EDIT', callFetchPrintTemplateForEdit, feathersApp);
}
function* callFetchPrintTemplateForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;

  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchPrintTemplateById, feathersApp, fetchParams);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}




export function* deletePrintTemplateSaga(feathersApp) {
  yield takeEvery('DELETE_PRINT_TEMPLATE', callDeletePrintTemplate, feathersApp);
}
function* callDeletePrintTemplate(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    yield delay(2000);
    if (id) {
      const { tenant, user } = yield select();
      const params = { tenant, user, id };
      result = yield call(api.deletePrintTemplate, feathersApp, params);
      yield common.doneDeleteRecord(id, 'print_template');
    }

    if (result) {
      browserHistory.push('/admin/print_template');
    }

  } catch (error) {
    yield common.showErrorDeleteRecord(error);
  }
}




export function* fetchListPrintTemplateSaga(feathersApp) {
  yield takeLatest('FETCH_TEMPLATE_LIST', callListFetchPrintTemplate, feathersApp);
}
function* callListFetchPrintTemplate(feathersApp, action) {
  const { silent, filters } = action;
  yield common.showProgressListTable(silent);

  try {
    const dataParams = {
      filters,
      list_type: 'print_template'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}




export function* previewPrintTemplateSaga(feathersApp) {
  yield takeLatest('PREVIEW_PRINT_TEMPLATE', callPreviewPrintTemplate, feathersApp);
}
function* callPreviewPrintTemplate(feathersApp, action) {
  try {
    yield put({ type: IS_LOADING_PREVIEW });

    const { payload } = action;
    const { template } = payload;
    const { output_type } = template;

    switch (output_type) {
      case 'dt:template_output_type:pdf':
        const { data: base64Pdf } = yield call(apiCommon.previewPdf, feathersApp, payload);
        yield put({ type: IS_DONE_LOADING_PREVIEW, payload: base64Pdf });
        break;

      default:
        break;
    }
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}